import { render, staticRenderFns } from "./newTrading.vue?vue&type=template&id=c1ec8a38&"
import script from "./newTrading.vue?vue&type=script&lang=js&"
export * from "./newTrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports